var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"discard"},[_vm._m(0),_c('div',{staticClass:"discard-table"},[_c('Table',{attrs:{"head":_vm.discardOrderTableHead,"width":"1654","height":"550"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"discard-top"},[_c('div',{staticClass:"discard-top__name"},[_vm._v("弃置单")])])
}]

export { render, staticRenderFns }